export default function () {
  return {
    isLoading: false,
    isOnline: true
  }
}
